export const advancedToolsEn = {
  advancedTools: {
    title: "Advanced Agricultural Tools",
    subtitle: "Professional features powered by real data",
    noParcels: "No Parcels Found",
    noParcelsDesc: "Please add a parcel first to use advanced tools",
    selectParcel: "Select a parcel",
    scouting: "Scouting",
    gdd: "GDD",
    harvest: "Harvest",
    vraExport: "VRA Export",
    timelapse: "Time-Lapse",
    rotation: "Rotation",
    tasks: "Tasks",
    carbon: "Carbon",
    ndviZones: "NDVI Zones",
    createScoutingReport: "Create Scouting Report",
    noParcelSelected: "No parcel selected",
    // Harvest Estimator
    harvestEstimator: "Enhanced Harvest Value Estimator",
    selectParcelOptional: "Select Parcel (Optional)",
    chooseParcel: "Choose existing parcel...",
    cropType: "Crop Type",
    areaHectares: "Area (Hectares)",
    enterArea: "Enter area in hectares",
    yieldFactor: "Expected Yield Factor",
    poorSeason: "Poor Season (60%)",
    belowAverage: "Below Average (80%)",
    averageSeason: "Average Season (100%)",
    goodSeason: "Good Season (120%)",
    excellentSeason: "Excellent Season (140%)",
    expectedQuality: "Expected Quality",
    basicQuality: "Basic Quality (80%)",
    standardQuality: "Standard Quality (100%)",
    premiumQuality: "Premium Quality (120%)",
    calculating: "Calculating...",
    calculateEstimation: "Calculate Estimation",
    yearOverYear: "Year-over-Year Analysis",
    previousYear: "Previous Year",
    growth: "Growth",
    marketTrend: "Market Trend",
    rising: "Rising",
    falling: "Falling",
    stable: "Stable",
    totalEstimatedValue: "Total Estimated Value",
    valuePerHectare: "Value per Hectare",
    estimatedCosts: "Estimated Costs",
    estimatedProfit: "Estimated Profit",
    profitMargin: "Profit Margin",
    yieldEstimate: "Yield Estimate",
    totalYield: "Total Yield",
    yieldPerHa: "Yield per Hectare",
    ndviAdjustment: "NDVI Adjustment",
    qualityMultiplier: "Quality Multiplier",
    seasonalForecast: "Seasonal Forecast",
    probability: "probability",
    exportComplete: "Export Complete",
    exportedSuccess: "Harvest estimation exported successfully",
    noDataExport: "No Data",
    noEstimationExport: "No estimation data to export",
    errorCalculating: "Failed to calculate harvest value estimation",
    enterValidArea: "Please enter a valid area in hectares",
    // Optimal Harvest
    optimalHarvest: "Optimal Harvest Calculator",
    calculateOptimalHarvest: "Calculate Optimal Harvest",
    optimalDate: "Optimal Date",
    maturity: "Maturity",
    netValue: "Net Value",
    daysFromNow: "Days from now",
    // Crop Rotation
    cropRotation: "Crop Rotation Planner",
    currentCrop: "Current Crop",
    soilHealthScore: "Soil Health Score",
    recommendedRotation: "Recommended Rotation (Next Year)",
    nBalance: "N Balance",
    riskReduction: "Risk Reduction",
    // Tasks
    automatedTasks: "Automated Task Recommendations",
    noRecommendations: "No recommendations yet",
    taskDate: "Date",
    confidence: "Confidence",
    accept: "Accept",
    reject: "Reject",
    taskAccepted: "Task accepted",
    taskRejected: "Task rejected",
    // Carbon
    carbonCalculator: "Carbon Footprint Calculator",
    howToUse: "How to use this calculator:",
    step1Title: "STEP 1: Register your agricultural activities",
    step1Desc: "Go to \"Field Notebook\" and record all activities for the period you want to analyze:",
    fertilizerApps: "Fertilizer applications (specify quantity in kg)",
    fuelUsage: "Fuel usage (diesel in liters)",
    pesticideApps: "Pesticide/herbicide applications (kg)",
    electricityConsumption: "Electricity consumption (kWh) for irrigation",
    step2Title: "STEP 2: Available Sentinel-2 vegetation index records",
    step2Desc: "The system can use available Sentinel-2 vegetation index records when available.",
    step3Title: "STEP 3: Select dates and calculate",
    step3Desc: "Choose the date range below and press \"Calculate Carbon Footprint\".",
    scientificMethodology: "Methodology: activity-based emissions using standard emission factors",
    emissions: "Emissions",
    sequestration: "Sequestration",
    netBalance: "Net Balance",
    startDate: "Start Date",
    endDate: "End Date",
    calculateCarbon: "Calculate Carbon Footprint",
    emissionBreakdown: "Emission Breakdown",
    fertilizer: "Fertilizer",
    pesticides: "Pesticides",
    diesel: "Diesel",
    electricity: "Electricity",
    globalBiomass: "Global Biomass Carbon Stock",
    totalCarbonStock: "Total Carbon Stock",
    aboveGround: "Above Ground",
    soilOrganicCarbon: "Soil Organic Carbon",
    co2Equivalent: "CO₂ Equivalent",
    climateZone: "Climate Zone",
    selectDates: "Please select start and end dates",
    noActivities: "No agricultural activities recorded in this period. Please register activities in \"Field Notebook\" first.",
    noNdviWarning: "Warning: No NDVI data available. Only emissions will be calculated, not carbon sequestration.",
    carbonSuccess: "Carbon footprint calculated successfully",
    loginRequired: "You must be logged in to calculate carbon footprint",
    // Timelapse
    timelapseTitle: "NDVI Time-Lapse Generator",
    indexType: "Index Type",
    captureNow: "Capture Now",
    capturing: "Capturing...",
    generateFrames: "Generate Frames",
    generating: "Generating...",
    framesReady: "frames ready",
    downloadAllFrames: "Download All Frames",
    ffmpegHint: "Use ffmpeg locally to create the video:",
    captureStarted: "Capture started",
    parcelsProcessed: "parcels processed",
    noFramesReceived: "No frames received",
    selectStartEnd: "Please select start and end dates",
    downloadingFrames: "Downloading all frames",
    framesReadyDownload: "frames ready to download",
    tasksExplanation: "Tasks are generated from parcel alerts, irrigation recommendations, drought risk, scouting reports, fertilization recommendations and unresolved incidents.",
    tasksAutomaticInactive: "Automatic task generation is not active yet. Recommendations will appear here once an alert, irrigation plan, drought signal, scouting report or fertilization plan is generated for this parcel.",
    carbonDataSourceNote: "Carbon indicators are estimated from available parcel, crop and management inputs. Biomass or satellite carbon layers require an active configured data source.",
    ruleBasedRecommendation: "Rule-based recommendation",
    noRealVraZones: "No real VRA zones available for this parcel. Run Nitrogen Optimizer first.",
    biomassDataLimited: "Satellite biomass layers not available (data source not configured).",
    biomassRequiresConfig: "Requires configuration",
    carbonSectionA: "Activity-based Carbon Footprint",
    carbonSectionADesc: "Estimated from farm activities and standard emission factors.",
    carbonSectionB: "Satellite Vegetation Biomass Indicator",
    carbonSectionBDesc: "Satellite vegetation biomass indicator based on available Sentinel-2 vegetation indices. This is not a verified carbon stock estimate.",
    carbonSectionBEmpty: "No Sentinel-2 vegetation index observations available for the selected date range.",
    carbonSectionBVigorLow: "Low vegetation vigor",
    carbonSectionBVigorModerate: "Moderate vegetation vigor",
    carbonSectionBVigorHigh: "High vegetation vigor",
    carbonSectionBObservations: "observations",
    carbonSectionC: "Verified Carbon Stock / Carbon Credits",
    carbonSectionCDesc: "Verified carbon stock and carbon credit estimates require a validated methodology, field calibration and external verification. This is not active yet.",
    statusActive: "Active",
    statusDataDependent: "Data-dependent",
    statusNotActive: "Not active",
    statusRequiresValidation: "Requires validation",
    ruleBasedBadge: "Rule-based",
    tasksActiveExplanation: "Tasks are generated from real parcel events such as irrigation recommendations, pest/disease risk, scouting reports, nitrogen recommendations and low-vigor zones.",
    tasksEmptyActive: "No task recommendations yet. Tasks will appear when relevant parcel events are detected.",
    tasksEmptyGuidance: "To generate tasks, create a scouting report, save an irrigation recommendation, run Nitrogen Optimizer, or analyze pest/disease risk.",
    generateTasksNow: "Generate tasks now",
    generatingTasks: "Generating...",
    tasksGenerated: "Tasks generated",
    taskTypeLabels: {
      review_irrigation: "Review irrigation plan",
      scout_pest_disease: "Scout parcel for pest or disease risk",
      followup_scouting: "Follow up scouting finding",
      review_vra_nitrogen: "Review variable-rate nitrogen application",
      inspect_low_vigor: "Inspect low-vigor zone"
    }
  },
  // Field Notebook
  fieldNotebook: {
    title: "Digital Field Notebook",
    parcel: "Parcel",
    newActivity: "New Activity",
    registerActivity: "Register Agricultural Activity",
    registerDesc: "Data will be automatically validated with satellite information",
    date: "Date",
    activityType: "Activity Type",
    planting: "Planting",
    irrigation: "Irrigation",
    fertilization: "Fertilization",
    pestControl: "Pest Control",
    pruning: "Pruning",
    harvestActivity: "Harvest",
    soilAnalysis: "Soil Analysis",
    other: "Other",
    productsUsed: "Products Used",
    productsPlaceholder: "E.g.: NPK 15-15-15 Fertilizer",
    quantity: "Quantity",
    unit: "Unit",
    unitPlaceholder: "kg, L, ha",
    cost: "Cost (€)",
    notes: "Notes",
    notesPlaceholder: "Observations, weather conditions, etc.",
    register: "Register Activity",
    registering: "Registering...",
    cancel: "Cancel",
    totalActivities: "Total Activities",
    totalCost: "Total Cost",
    validated: "Validated",
    noActivities: "No activities registered",
    startRegistering: "Start by registering your first agricultural activity",
    activityRegistered: "Activity Registered",
    activityRegisteredDesc: "The activity has been registered and is being validated with satellite data",
    products: "Products",
    satelliteValidation: "Satellite Validation",
    improvementDetected: "Improvement detected",
    pending: "Pending",
    validatedStatus: "Validated",
    anomalyDetected: "Anomaly Detected",
    noData: "No Data",
    loadingNotebook: "Loading field notebook...",
    errorLoading: "Failed to load activities",
    select: "Select...",
    calendarView: "Activity Calendar",
    calendarActivities: "activities",
    noActivitiesDay: "No activities on this day",
    listView: "List",
    calendarViewTab: "Calendar",
  },
  // Advanced Vegetation Analysis
  vegetation: {
    title: "Advanced Vegetation Analysis",
    subtitle: "Copernicus Sentinel-2 spectral indices with adaptive Meta Index",
    noParcels: "No parcels registered",
    noParcelsDesc: "Register a parcel to access advanced vegetation analysis.",
    loadingParcels: "Loading parcels...",
    selectParcel: "Select parcel",
    analysis: "Analysis",
    contrastView: "Contrast View",
    indexGuide: "Index Guide",
    phenology: "Phenology",
    autoMetaIndex: "Automatic Meta Index",
    autoMetaIndexDesc: "The system automatically selects the most relevant index based on your crop's phenological stage.",
    selectParcelDesc: "Choose a parcel from the selector above to view its vegetation analysis.",
    dynamicColorScale: "Dynamic Color Scale Adjustment",
    dynamicColorScaleDesc: "Fine-tune brightness, contrast, and saturation of satellite imagery. Choose color scales optimized for different analyses.",
    howToUse: "How to Use",
    adjustParams: "Adjust parameters to optimize visualization",
    colorScaleLegend: "Color Scale Legend",
    usageTips: "Usage Tips",
    tip1: "Increase contrast to highlight vegetation differences",
    tip2: "Use Viridis scale for accessible visualization",
    tip3: "Auto-stretch optimizes range for your specific field",
    tip4: "Magma scale works best for burn analysis",
    coordinates: "Coordinates",
    whenToUse: "When to use",
    limitations: "Limitations",
    valueInterpretation: "Value interpretation",
    low: "Low",
    medium: "Medium",
    high: "High",
    optimal: "Optimal",
    recommendedByStage: "Recommended Index by Phenological Stage",
    recommendedByStageDesc: "Each crop stage has more appropriate vegetation indices for monitoring",
    quickReference: "Quick Reference",
    earlyStages: "Early Stages (0-30 days)",
    earlyStagesDesc: "Use <strong>MSAVI</strong> to ignore soil noise when plants are small and lots of soil is visible.",
    activeGrowth: "Active Growth (30-75 days)",
    activeGrowthDesc: "<strong>NDVI</strong> is the standard for evaluating biomass and vigor during vegetative growth.",
    denseCanopy: "Dense Canopy (75+ days)",
    denseCanopyDesc: "Switch to <strong>RECI/NDRE</strong> when NDVI saturates. These indices detect nitrogen variations.",
    entireCycle: "Entire Cycle",
    entireCycleDesc: "<strong>NDMI</strong> to monitor water content at any time, especially useful for irrigation planning.",
    days: "Days",
    noSentinelImages: "No valid Sentinel-2 images found for this date range.",
  }
};
